/**
 * 割り込みの報告（ADR-0042 の 2.1・2.5）。返事が流れている途中・読み上げの途中で次の発言を送ったときに、
 * 「直前の返事がどこまで届いたか」を数だけで Gateway に送る（文は送らない。文の正は Gateway の記録）。
 * 形は packages/contracts の ReplyDelivery と同じ（PWA は Node の部品を取り込めないので写し。delivery.test.ts で形を確かめる）。
 * 位置は返事の文（Gateway が流した文。最後の取り消しの後）の中の文字（コードポイント）の数
 */
import type { SpokenPosition } from "./speech.js";

export interface ReplyDeliveryReport {
  trace_id: string | null;
  status: "interrupted";
  retracts_seen: number;
  screen?: { shown_chars: number };
  voice?: SpokenPosition;
  stopped_at: string;
}

/** 文字（コードポイント）の数。Gateway・DB と同じ数え方 */
export function cpLength(s: string): number {
  let n = 0;
  for (const _ of s) n++;
  return n;
}

/** 止めた時点の、返事の届き方 */
export interface ReplyState {
  /** 返事の trace（start で受けたもの。まだ受けていなければ null） */
  trace_id: string | null;
  /** 画面に出していた文（最後の取り消しの後） */
  shown: string;
  /** 返事が全部届いた（final を受けた）か */
  final: boolean;
  /** 受けた取り消し（retract）の数 */
  retracts: number;
  /** 読み上げの位置。読み上げていない・読み終えたときは null */
  voice: SpokenPosition | null;
}

/**
 * 報告を作る。返事が全部届いて読み上げも終わっている（または読み上げていない）なら null（報告は送らない。
 * そのときの文脈は今までと 1 文字も変わらない）。画面を消した・電波が切れただけのときは、そもそも呼ばない
 */
export function deliveryReport(s: ReplyState, now: Date = new Date()): ReplyDeliveryReport | null {
  if (s.final && !s.voice) return null;
  return {
    trace_id: s.trace_id,
    status: "interrupted",
    retracts_seen: s.retracts,
    screen: { shown_chars: cpLength(s.shown) },
    ...(s.voice ? { voice: s.voice } : {}),
    stopped_at: now.toISOString(),
  };
}
